const vip = {
  title: 'VIP',
  subTitle1: 'ما هو VIP',
  subTitle2: 'تجربة VIP',
  subTitle3: 'فترة صلاحية VIP',
  subTitle4: 'ترقية VIP',
  subTitle5: 'حماية مستوى VIP',
  subTitle6: 'تخفيض مستوى VIP',
  subTitle7: 'نقاط خبرة VIP',
  content1:
    'VIP هي حالة خاصة داخل البرنامج. يمكن أن يؤدي الحصول على VIP إلى فتح امتيازات متعددة داخل البرنامج. كلما ارتفع المستوى، زاد عدد الامتيازات التي يمكنك فتحها.',
  content2:
    'يمكنك الحصول على نقاط خبرة VIP من خلال إعادة شحن العملات في البرنامج (1 عملة ذهبية = 1 خبرة VIP). يمكن استخدام خبرة VIP لترقية مستوى VIP؛ إذا قمت باسترداد الأموال، فسيتم خصم كل خبرة VIP التي اكتسبتها من خلال إعادة الشحن.',
  content3: 'كل مستوى VIP صالح لمدة 60 يومًا، بدءًا من اليوم الذي تحصل فيه على VIP.',
  content4:
    'إذا وصلت تجربة VIP الخاصة بك إلى متطلبات الترقية إلى مستوى أعلى خلال فترة صلاحية VIP، فسيتم ترقية مستوى VIP الخاص بك على الفور، وسيتم إعادة تعيين تجربة VIP الخاصة بك إلى الصفر، وسيتم إعادة حساب أيام VIP.',
  content5:
    'إذا وصلت تجربة VIP الخاصة بك إلى متطلبات مستوى الحماية خلال فترة صلاحية VIP، فسيتم تجديد VIP الخاص بك تلقائيًا بعد انتهاء صلاحيته.',
  content6:
    'إذا لم تكن خبرة VIP الخاصة بك كافية لحماية المستوى والترقية، فسيتم تخفيض مستوى VIP إلى المستوى المقابل.',
  table: {
    level: 'المستوى',
    totalRechargeCoins: 'إجمالي شحن العملات',
    upgradeVipExp: 'الخبرة المطلوبة لـVIP',
    maintainVipExp: 'خبرة الحفاظ على VIP',
  },
};

export default {
  vip,
};
